/**
 * <TutorRow> — un tuteur de l'élève, en ligne de « Mon tuteur » ou « Mes tuteurs » (molecule).
 *
 * Sa capsule (le nœud jaune), son nom, ce que la ligne dit de lui (`caption` : ses matières), le
 * nombre de messages non lus, et le chevron. Toute la ligne ouvre SA conversation.
 *
 * Sans `onPress`, la ligne ne presse pas et ne montre pas de chevron : elle présente le tuteur,
 * rien de plus. C'est ainsi que l'équipe se lit si la messagerie est retirée.
 *
 * `selected` : sa conversation est ouverte à côté (deux volets). La capsule prend l'anneau de
 * sélection du livre (le nœud reste), la ligne le fond des lignes mises en avant (`primary-soft`,
 * celui de la ligne de l'élève au classement), et la pastille des non-lus se retire : une
 * conversation ouverte est lue.
 *
 * Elle ne dessine pas de carte : l'équipe est UNE carte-liste.
 *
 * C'est `<PersonRow>` avec la capsule du tuteur : la ligne d'une personne, partagée avec la messagerie
 * du masteur, où un élève prend le rond simple.
 */
import React from "react"

import { type UITutor } from "../../../ports/primary/ui/types"
import { tutorShortName } from "../../../ports/primary/ui/formatters/liveSessionFormatter"
import { PERSON_AVATAR_SIZE, PersonRow } from "../PersonRow"

export type TutorRowProps = {
    tutor: UITutor
    /** Sous le nom : ses matières. Absent, le nom est seul. */
    caption?: string
    /** Messages non lus de ce tuteur — au-delà de 9, la pastille dit « 9+ ». Défaut 0, rien. */
    unreadCount?: number
    /** Toute la ligne presse. Absent → elle ne presse pas, et n'a pas de chevron. */
    onPress?: () => void
    /** Sa conversation est ouverte à côté. Défaut `false`. */
    selected?: boolean
    testID?: string
}

/** La capsule du livre, dans sa taille de liste. */
export const TUTOR_AVATAR_SIZE = PERSON_AVATAR_SIZE

export function TutorRow(props: TutorRowProps) {
    const { tutor, ...row } = props
    return <PersonRow {...row} name={tutorShortName(tutor)} avatarUrl={tutor.avatarUrl} avatarVariant="tutor" />
}
